import { render, staticRenderFns } from "./linuc101.vue?vue&type=template&id=73670009"
import script from "./linuc101.vue?vue&type=script&lang=js"
export * from "./linuc101.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports